import React from "react";
import ReactDOM from "react-dom/client";
import Cookies from "js-cookie";
import {
  configureApiClient,
  setSessionExpiredHandler,
} from "@shared/api/client";
import { expireStaffSession } from "@shared/lib/staffSession";
import "@/index.css";
import App from "@/App";

// PR 11 ST 2 — CRA bootstrap. Vite shells call configureApiClient()
// from their own main.tsx with `import.meta.env`. See
// memory/project_pr10_api_client_deferred_factory.md.
configureApiClient({
  baseURL: process.env.REACT_APP_BACKEND_URL ?? "",
  getToken: () => Cookies.get("staff_token") ?? null,
});
// F-W: a session 401 on a staff page → "session expired" login, then back.
setSessionExpiredHandler(expireStaffSession);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
